export function UnderlineCheck(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.999837 11.7646H10.9998C11.4582 11.7646 11.8332 12.1396 11.8332 12.5979C11.8332 13.0562 11.4582 13.4312 10.9998 13.4312H0.999837C0.541504 13.4312 0.166504 13.0562 0.166504 12.5979C0.166504 12.1396 0.541504 11.7646 0.999837 11.7646ZM5.17484 8.34789C4.52484 8.98956 3.47484 8.98956 2.82484 8.33956L0.999837 6.51456C0.541504 6.05623 0.549837 5.31456 1.02484 4.87289C1.47484 4.43956 2.1915 4.45623 2.62484 4.88956L3.99984 6.26456L9.35817 0.906226C9.80817 0.456226 10.5332 0.456226 10.9832 0.906226L11.0165 0.939559C11.4665 1.38956 11.4665 2.12289 11.0082 2.57289L5.17484 8.34789Z"
        fill="currentColor"
      />
    </svg>
  )
}
